import { WorkspaceSwitcherList } from "@/pages/workspaces/home/WorkspaceSwitcher";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@cohesive/ui-components/ui/drawer";

/**
 * Mobile chrome for the workspace switcher: the same searchable list the
 * desktop popover hosts, presented as a bottom sheet (the native phone
 * pattern — a 384px popover fighting a 390px viewport and the keyboard is
 * not). Selecting navigates; the mobile gates then re-render `/` or
 * `/workspaces/:id` as the mobile surface.
 */
export function MobileWorkspaceSwitcherSheet({
  open,
  onOpenChange,
  currentWorkspaceId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Workspace being viewed; undefined on the unscoped home. */
  currentWorkspaceId?: string;
}) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent
        className="max-h-[85vh]"
        // Focusing the search on open would pop the keyboard over the list;
        // tapping the field still focuses it for those who want to type.
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DrawerHeader className="text-left">
          <DrawerTitle>Switch workspace</DrawerTitle>
        </DrawerHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-2 pb-safe">
          <WorkspaceSwitcherList
            currentWorkspaceId={currentWorkspaceId}
            onDone={() => onOpenChange(false)}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export default MobileWorkspaceSwitcherSheet;
